// extracted by mini-css-extract-plugin
export default {"root":"style_root__Cls-P","list":"style_list__ptpNr"};